module.exports = __webpack_public_path__ + "microphone-8b119c8dfe86f67d6cdb.svg";